import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

// GenerateEquipamentoColumns

type Props = {
  onActionEditar: (
    Id: number | null,
    openState: boolean,
    openAnalise: boolean,
  ) => void;
  onActionDeletar: (Id: number | null, openState: boolean) => void;
  read: boolean;
};

export const GenerateEquipamentoColumns = ({
  onActionEditar,
  onActionDeletar,
  read,
}: Props): GridColDef[] => {
  const StatusBadge = ({
    label,
    color,
  }: {
    label: string;
    color: "green" | "yellow" | "blue";
  }) => {
    const bgClass =
      color === "green"
        ? "bg-[#009688]"
        : color === "yellow"
          ? "bg-[#FFC107]"
          : "bg-[#00BCD4]";
    return (
      <div
        className={`${bgClass} text-white px-2 py-1 rounded text-xs font-bold uppercase w-full text-center`}
      >
        {label}
      </div>
    );
  };

  return [
    {
      field: "NomeMaquinaEquip",
      filterable: false,
      headerName: "Maquina/Equipamento",
      flex: 1,
      minWidth: 250,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Descricao",
      filterable: false,
      headerName: "Descricao",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Tipo",
      filterable: false,
      headerName: "Tipo de Equipamento",
      width: 160,
      sortable: false,
      renderCell: (params) => {
        const isPropria = params.value === "0";
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <StatusBadge
              label={isPropria ? "Próprio" : "Alugado"}
              color={isPropria ? "green" : "yellow"}
            />
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      headerName: "Quantidade",
      width: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdDiarioObrasEquipamento",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        if (read !== false) return null;

        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onClick={() => onActionEditar(params.value, true, false)}
            >
              <DynamicIcon
                nameIcon="EditRounded"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={25}
                className="text-red-500"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};
